import React from 'react';
import { CheckCircle2, PenLine, Plus } from 'lucide-react';
import { dataIt } from '../../haccpApi';
import { nuovaFirma } from './useFirme';

const Spazio = ({ s, onFirma, onIgnora, testid }) => {
  const daFare = !s.firmata && !s.ignorata;
  return (
    <div className={`rounded-xl border p-2.5 flex flex-wrap items-center justify-between gap-2 ${daFare ? 'border-amber-300' : 'border-gray-200'}`} data-testid={testid}>
      <div className="min-w-0">
        <p className="text-sm font-medium text-gray-900 break-words">{s.ruolo}</p>
        <p className="text-[11px] text-gray-500">
          pag. {s.pagina}{s.nome ? ` · ${s.nome}` : ''}
          {s.applicata && ` · firmato da ${s.applicata.firmatario} il ${dataIt(s.applicata.il)}`}
          {s.firmata && !s.applicata && ' · già firmato'}
          {s.ignorata && ' · segnato come firmato a mano'}
        </p>
      </div>
      {daFare ? (
        <div className="flex items-center gap-2">
          <button onClick={() => onIgnora(true)} className="text-[11px] text-gray-500 underline" data-testid={`${testid}-ignora`}>Firmato a mano</button>
          <button onClick={onFirma} className="h-9 px-3 rounded-lg bg-sky-700 text-white text-xs font-semibold flex items-center gap-1" data-testid={`${testid}-firma`}><PenLine className="h-3.5 w-3.5" />Firma</button>
        </div>
      ) : s.ignorata ? (
        <button onClick={() => onIgnora(false)} className="text-[11px] text-sky-700" data-testid={`${testid}-ripristina`}>Da firmare</button>
      ) : <CheckCircle2 className="h-4 w-4 text-emerald-600" />}
    </div>
  );
};

export const DocumentoFirme = ({ d, onFirma, onIgnora, onRicontrolla }) => (
  <div className="rounded-2xl border border-gray-200 p-3 space-y-2" data-testid={`firme-doc-${d.id}`}>
    <div className="flex items-start justify-between gap-2">
      <p className="text-sm font-bold text-gray-900 min-w-0 break-words">{d.nome}</p>
      <span className={`shrink-0 px-2 py-0.5 rounded-full text-[11px] font-bold ${d.mancanti ? 'bg-amber-100 text-amber-800' : 'bg-emerald-100 text-emerald-700'}`} data-testid={`firme-doc-${d.id}-mancanti`}>
        {d.stato === 'errore' ? 'Non letto' : d.mancanti ? `${d.mancanti} da firmare` : 'Completo'}
      </span>
    </div>
    {d.spazi.map((s) => <Spazio key={s.id} s={s} testid={`firme-spazio-${d.id}-${s.id}`} onFirma={() => onFirma(d, s)} onIgnora={(v) => onIgnora(d, s, v)} />)}
    <div className="flex flex-wrap gap-3">
      <button onClick={() => onFirma(d, nuovaFirma(d, d.nome).spazio)} className="text-xs font-semibold text-sky-700 flex items-center gap-1" data-testid={`firme-doc-${d.id}-aggiungi`}><Plus className="h-3.5 w-3.5" />Aggiungi una firma</button>
      <button onClick={() => onRicontrolla(d)} className="text-xs text-gray-600" data-testid={`firme-doc-${d.id}-ricontrolla`}>Ricontrolla</button>
    </div>
  </div>
);
